import React, { useState, useRef } from 'react'
import Modal from 'react-bootstrap-modal'
import FlashAlert from '../flash-alert'
import { ajaxPost } from '../../ajax'

const CancelGame = ({game, gameIds, onClose, onCancel}) => {
  const [reason, setReason] = useState('')
  const [alert, setAlert] = useState(null)
  const [optionSelected, setOptionSelected] = useState(false)
  const [showError, setShowError] = useState(null)
  const [loading, setLoading] = useState(false)

  const reasons = ['Weather', 'Field time no longer available', 'Not enough players', 'Last minute drops', 'Operational changes']
  const batch = !game

  const reasonClass = (reasonText) => { return reason == reasonText ? 'selected' : '' }

  const otherOptionSelected = () => { return !reasons.includes(reason) && optionSelected }

  const selectOption = (value) => {
    setShowError(false)
    setReason(value)
    setOptionSelected(true)
  }

  const onSubmit = (e) => {
    if (!optionSelected || reason == '') {
      setShowError(true)
      return
    }

    batch ? batchCancel() : gameCancel()
  }

  const gameCancel = async () => {
    setLoading(true)
    const response = await ajaxPost(`/admins/reservations/${game.id}/cancellations`, { cancellation: { text: reason } })
    const json = await response.json()
    setLoading(false)
    if (json.alert)
      setAlert(json.alert)
    else
      onCancel()
  }

  const batchCancel = async () => {
    setLoading(true)
    await ajaxPost('/admins/reservations/batch_cancel', { game_ids: gameIds, reason: reason })
    setLoading(false)
    onCancel()
  }

  return (
    <Modal container={document.body} show={true} onHide={onClose} dialogClassName='open-game-cancellation-modal'>
      <Modal.Header closeButton>
        <Modal.Title>{`Cancel Game${batch ? '(s)' : ''}`}</Modal.Title>
      </Modal.Header>
      <div className={'open-game-cancellation' + (loading ? ' isLoading' : '')}>
        { alert && <FlashAlert text={alert.text} type={alert.type} constant onHide={() => setAlert(null)} />}
        { loading && <div className='animated-spinner'></div> }
        <div className='open-game-cancellation__reason'>
          <h2>Reason</h2>
          {reasons.map((r, i) => {
            return <button key={i} className={reasonClass(r)} onClick={(e) => selectOption(e.target.innerHTML)}>{r}</button>
          })}
          <button className={otherOptionSelected() ? 'selected' : ''} onClick={(e) => selectOption('')}>Other</button>
          { otherOptionSelected() &&
            <div>
              <textarea placeholder='Other...' value={reason} onChange={(e) => selectOption(e.target.value)} />
            </div>
          }
        </div>
        {showError && <span className='cancel-error'>Please select a cancellation reason</span>}
        <div className='game-cancellation__footer'>
          <button className='cancel-open-game' onClick={onSubmit}>{`Cancel Game${batch ? '(s)' : ''}`}</button>
        </div>
      </div>
    </Modal>
  )
}

export default CancelGame
